import fetch from '@/utils/fetch'

export function addProblemsMainFromStartMain (data) {
  return fetch({
    url: '/addProblemsMainFromStartMain',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_managerPage.js